<template>
  <div class="login flex">
    <div class="item">
      <p class="must">所在省市</p>
      <el-cascader
        v-model="model.areaCode"
        :options="area"
        ref="cascader"
        style="width: 437px"
        @change="areachange"
      >
      </el-cascader>
    </div>
    <div class="item">
      <p class="must">姓　　名</p>
      <el-input
        v-model="model.name"
        placeholder="请输入您的姓名"
        style="width: 437px"
      >
      </el-input>
    </div>

    <div class="item" style="width: 50%">
      <p class="must">高考年份</p>
      <el-select
        v-model="model.vintage"
        placeholder="请选择"
        style="width: 130px"
        @change="totalPointsinput"
      >
        <el-option
          v-for="item in planYears"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="item" style="width: 50%">
      <p class="must">性　　别</p>
      <el-radio-group v-model="model.sex">
        <el-radio :label="1">男</el-radio>
        <el-radio :label="2">女</el-radio>
      </el-radio-group>
    </div>
    <div class="item">
      <p>特殊情况</p>
      <div class="choiceSubject flex">
        <button
          v-for="(item, index) in specialPlanl"
          @click="setplanl(item)"
          :class="{ current: item.disabled }"
        >
          {{ item.label }}
        </button>
      </div>
    </div>
    <div class="item choiceSubjectbox">
      <p class="must">高考科目</p>
      <div class="choiceSubject flex">
        <button
          v-for="(item, index) in choiceSubject"
          @click="choiceSubjectclick(item)"
          :class="{ current: item.disabled }"
          :style="{ 'margin-top': index > 2 ? '10px' : '0' }"
          :disabled="model.selective.length >= 3 && !item.disabled"
        >
          {{ item.text }}
        </button>
      </div>
    </div>
    <div class="item">
      <p class="must">分数排名</p>
      <div class="sore">
        <el-input
          v-model="model.totalPoints"
          placeholder="请输入您的分数/预估分"
          style="width: 270px"
          type="number"
          @input="totalPointsinput"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
          ><span slot="suffix">分</span></el-input
        >
        <div class="num" v-if="$store.state.userinfo.num !== null">
          <p class="flex">
            剩余{{ $store.state.userinfo.num }}次
            <el-tooltip
              effect="dark"
              content="只能更改两次，超限后普通用户需购买会员，会员用户需购买次数"
              placement="top-start"
              ><i>?</i></el-tooltip
            >
          </p>
        </div>
      </div>
      <el-input
        v-model="model.precedence"
        placeholder="您的排名"
        disabled
        type="text"
        style="width: 130px; margin-left: 10px"
      >
        <span slot="suffix">名</span>
      </el-input>
    </div>
    <div class="item button">
      <p></p>
      <el-button type="primary" @click="submit" :loading="precedencestate"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { ajaxGetDictItems, updateSelective } from "@/api/api";
import { selectPrecedence } from "@/api/login";
export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      planYears: [],
      choiceSubject: [],
      area: [],
      model: {
        selective: [],
        precedence: "",
        sex: 1,
        specialPlan: [],
      },
      loginBtn: false,
      precedencestate: false,
      oldtotalPoints: "",
      userinfo: "",
      oldYear: "",
      specialPlanl: [
        // 0地方专项计划、1边防子女
        { label: "地方专项计划", value: 0, disabled: false },
        { label: "边防子女", value: 1, disabled: false },
      ],
    };
  },
  created() {
    this.getajaxGetDictItems();
    this.getchoicesubject();
    //省市区数据只要山东省的
    this.$Jpcaa.forEach((item) => {
      if (item.label == "山东省") {
        let area = item;
        area.children.forEach((item) => {
          delete item.children[0];
        });
        this.area = [area];
      }
    });
  },
  methods: {
    checkboxchange(e) {
      // console.log(e);
    },
    async getchoicesubject() {
      //高考选科
      let res = await ajaxGetDictItems("choice_subject");
      let choiceSubject = res.result;
      choiceSubject.forEach((item) => {
        item.disabled = false;
      });
      this.choiceSubject = choiceSubject;

      if (!this.$store.state.userinfo.totalPoints) return false;
      // this.$set("model", this.$store.state.userinfo);
      this.model = JSON.parse(JSON.stringify(this.$store.state.userinfo));
      if (this.model.specialPlan) {
        this.model.specialPlan = this.model.specialPlan.toString();
        this.specialPlanl.forEach((item) => {
          if (this.model.specialPlan.includes(item.value)) {
            item.disabled = true;
          }
        });
      }
      this.model.areaCode = this.model.areaCode.split(",");
      this.model.selective = this.model.selective.split(",");
      let selective = this.model.selective;
      this.choiceSubject.forEach((item) => {
        if (
          selective[0] == item.value ||
          selective[1] == item.value ||
          selective[2] == item.value
        ) {
          item.disabled = true;
        }
      });
    },
    getajaxGetDictItems() {
      //高考年份
      ajaxGetDictItems("plan_years").then((res) => {
        this.planYears = res.result;
        if (!this.$store.state.userinfo.totalPoints) {
          this.$set(this.model, "vintage", this.planYears[0].value);
        }
      });
    },
    setplanl(item) {
      item.disabled = !item.disabled;
      this.model.specialPlan = [];
      this.specialPlanl.forEach((item) => {
        if (item.disabled) {
          this.model.specialPlan.push(item.value);
        }
      });
      if (this.model.specialPlan.length > 0) {
        this.model.specialPlan = this.model.specialPlan.toString();
      } else {
        this.model.specialPlan = "";
      }
    },
    choiceSubjectclick(data) {
      this.model.selective = [];
      this.choiceSubject.forEach((item) => {
        if (data.value == item.value) {
          item.disabled = !item.disabled;
        }
        if (item.disabled) {
          this.model.selective.push(item.value);
        }
      });
      // this.choiceSubject.forEach((item) => {});
    },
    areachange(e) {
      let node = this.$refs["cascader"].getCheckedNodes()[0];
      this.model.area = [
        node.parent.parent.label,
        node.parent.label,
        node.label,
      ];
    },

    totalPointsinput() {
      if (this.model.totalPoints) {
        if (this.model.totalPoints > 750) {
          this.model.totalPoints = "";
          return false;
        }
        if (
          this.oldtotalPoints == this.model.totalPoints &&
          this.oldYear == this.model.vintage
        ) {
          return false;
        }
        let json = {
          section: this.model.totalPoints,
          vintage: this.model.vintage,
        };
        this.precedencestate = true;
        selectPrecedence(json).then((res) => {
          this.oldtotalPoints = this.model.totalPoints;
          this.model.precedence = res.result.allAccumulate;
          this.oldYear = this.model.vintage;
          this.precedencestate = false;
        });
      }
    },
    submit() {
      if (!this.model.areaCode) {
        this.$message.error("请选择所在省市");
        return false;
      } else {
        this.model.area = this.model.area.toString();
        this.model.areaCode = this.model.areaCode.toString();
      }
      if (!this.model.name) {
        this.$message.error("请输入您的姓名");
        return false;
      }
      if (!this.model.vintage) {
        this.$message.error("请选择高考年份");
        return false;
      }

      if (this.model.selective.length < 3) {
        this.$message.error("请选择3个高考科目");
        return false;
      } else {
        this.model.selective = this.model.selective.toString();
      }
      if (!this.model.totalPoints) {
        this.$message.error("请输入您的分数/预估分");
        return false;
      } else if (this.model.totalPoints < 150) {
        this.$message.error("请输入大于150的分数/预估分");
        return false;
      }
      if (this.precedencestate) {
        this.$message.error("正在获取排名，请稍等！");
        return false;
      }
      this.model.id = this.$store.state.userinfo.id;
      if (!this.$store.state.userinfo.avatar) {
        if (this.model.sex == 1) {
          this.model.avatar =
            "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/men.png";
        } else {
          this.model.avatar =
            "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/women.png";
        }
      } else {
        if (
          this.$store.state.userinfo.avatar.includes("men.png") ||
          this.$store.state.userinfo.avatar.includes("women.png")
        ) {
          if (this.model.sex == 1) {
            this.model.avatar =
              "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/men.png";
          } else {
            this.model.avatar =
              "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/women.png";
          }
        }
      }
      if (this.model.specialPlan) {
        if (this.model.specialPlan.length > 0) {
          this.model.specialPlan = this.model.specialPlan.toString();
        } else {
          this.model.specialPlan = "";
        }
      } else {
        this.model.specialPlan = "";
      }
      this.precedencestate = true;
      let json = JSON.parse(JSON.stringify(this.model));
      delete json.num;
      updateSelective(json).then((res) => {
        if (res.success) {
          this.$message.success("保存成功");
          this.$emit("getselective");
          this.$store.commit("setuserstate", false);
          this.$store.commit("setSelective", this.model.selective);
          this.$store.commit("setScore", this.model.totalPoints);
          this.$store.commit("setPrecedence", this.model.precedence);
          this.$store.dispatch("updateSelective");
          setTimeout(() => {
            this.reload();
          }, 500);
        } else {
          if (res.message == "修改次数为0") {
            if (this.$store.state.userinfo.member != 1) {
              //如果是普通用户或试用期会员直接打开购买会员窗口
              this.$store.commit("setmembertype", 0);
              this.$store.commit("setmemberstate", true);
            } else {
              //如果是会员打开购买次数
              this.$store.commit("setmembertype", 1);
              this.$store.commit("setmemberstate", true);
            }
          }
        }
        this.precedencestate = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  flex-wrap: wrap;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-input__inner {
      border-radius: 8px;
      height: 45px;
    }
    /deep/ .el-input__suffix {
      line-height: 45px;
      margin-right: 5px;
    }
    .sore {
      position: relative;
      .num {
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
        p {
          // width: 65px;
          font-size: 12px;
          justify-content: flex-end;
          i {
            display: block;
            width: 15px;
            height: 15px;
            text-align: center;
            line-height: 15px;
            border: 1px solid #e4e4e4;
            border-radius: 50%;
            margin-left: 5px;
            font-size: 12px;
          }
        }
      }
    }
    p {
      width: 110px;
      color: #999999;
      font-size: 16px;
    }
    .must {
      position: relative;
      &::before {
        content: "*";
        color: red;
        position: absolute;
        left: -8px;
        top: -3px;
      }
    }
    .choiceSubject {
      width: 420px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;

      button {
        display: block;
        width: 130px;
        height: 45px;
        background: none;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
        margin-left: 10px;
        box-sizing: border-box;
        &:hover {
          border-color: #660874;
          color: #660874;
          background: #fff4ee;
        }
        &:nth-child(1),
        &:nth-child(4) {
          margin-left: 0;
        }
      }
      button[disabled="disabled"] {
        cursor: not-allowed;
        border-color: #e5e5e5;
        color: #ccc;
        background: #fff;
        &:hover {
          border-color: #e5e5e5;
          color: #ccc;
          background: #fff;
        }
      }
      .current {
        border-color: #660874;
        color: #660874;
        background: #fff4ee;
      }
    }
  }
  .button {
    margin-top: 20px;
    justify-content: center;
    .el-button {
      width: 360px;
      height: 45px;
      // background: #e68b57;
      border-radius: 8px;
      color: #fff;
      border: 0;
      font-weight: 700;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
